import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-accreditation-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'provider-accreditation-service-materials' })
export default class ProviderAccreditatonServiceMaterialsController extends BaseController {

  @OnMount('tab-control')
  onMountTab(event: MountEvent): void {
    const api = event.target as TabControlAPI;
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser, nrSeqAccreditation });
    ShouldRenderTabsService.chooseDefaultTab(api, ['procedures', 'materials', 'outsourcedServices', 'services']);

  }

  @OnMount('tab-with-content-mat')
  onMountProMaterials(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'materials');
  }

  @OnMount('tab-with-content-proc')
  onMountProcedures(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'procedures');
  }

  @OnMount('tab-with-content-outsourced-services')
  onMountOutsourcedServices(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'outsourcedServices');
  }

  @OnMount('tab-with-content-services')
  onMountServices(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'services');
  }

}
